import _ from 'lodash';

import RefData from 'ref-data';

import { assetRefService } from '../../common/Services';

const allowPublish = (model, isExperiencePublished) =>
  model.status.id !== RefData.Enum.STATUS.CAMPAIGNPROMOTION.PUBLISHED && isExperiencePublished;

const allowDraft = (model, isExperiencePublished) =>
  model.status.id !== RefData.Enum.STATUS.CAMPAIGNPROMOTION.DRAFT && isExperiencePublished;

const promotionImage = _.memoize(
  (model, isMacroExperience) =>
    // NextGen experience promotion images always show locked images
    // Macro ones are not changed
    !(isMacroExperience && model.isUnlocked)
      ? assetRefService.pathFromAssetRef(model.lockedThumbnailAssetRef)
      : assetRefService.pathFromAssetRef(model.thumbnailAssetRef),
  (model, isMacroExperience) => `cache-${model.thumbnailAssetRef}-${model.lockedThumbnailAssetRef}-${isMacroExperience}`
);

const hasImage = _.memoize(
  (model, isMacroExperience) =>
    promotionImage(model, isMacroExperience) &&
    // Check for both locked and unlocked images in Macro and only locked one in NextGen
    ((isMacroExperience && (model.thumbnailAssetRef || model.lockedThumbnailAssetRef)) || model.thumbnailAssetRef),
  (model, isMacroExperience) => `cache-${model.thumbnailAssetRef}-${model.lockedThumbnailAssetRef}-${isMacroExperience}`
);

const promotionHeader = _.memoize(
  (model, isMacroExperience) => {
    if (isMacroExperience) {
      // For Macro experiences, if the promotion is unlocked, show the heading (if it exists) or name. If it's locked, show the locked message (if it exists) or name.
      return model.isUnlocked ? model.heading || model.name : model.lockedMessage || model.name;
    }
    // For NextGen experiences, if the locked message exists, show it, otherwise show the name.
    return model.lockedMessage || model.name;
  },
  (model, isMacroExperience) => `cache-${model.heading}-${model.lockedMessage}-${model.name}-${isMacroExperience}`
);

export { allowPublish, allowDraft, promotionImage, hasImage, promotionHeader };
